import { useEffect, useState } from "react";
import axios from "axios";
import { PRODUCTS as MOCK_PRODUCTS } from "../mock";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const EVENT_NAME = "zeid-products-updated";

/**
 * Returns all products (admin-added + static mock).
 * Refetches on mount AND whenever `invalidateProductsCache()` is called.
 */
export function useAllProducts() {
  const [products, setProducts] = useState([...MOCK_PRODUCTS]);

  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const { data } = await axios.get(`${API}/products`, { timeout: 8000 });
        if (!alive) return;
        const custom = Array.isArray(data) ? data : [];
        setProducts([...custom, ...MOCK_PRODUCTS]);
      } catch {
        if (alive) setProducts([...MOCK_PRODUCTS]);
      }
    };
    load();

    const onUpdate = () => load();
    window.addEventListener(EVENT_NAME, onUpdate);
    return () => {
      alive = false;
      window.removeEventListener(EVENT_NAME, onUpdate);
    };
  }, []);

  return products;
}

/**
 * Notify all pages using useAllProducts to refetch.
 */
export function invalidateProductsCache() {
  try { window.dispatchEvent(new Event(EVENT_NAME)); } catch (_) {}
}
